import React, { useEffect, useState } from "react";
import { selectCurrent } from '../redux/theme/selectors'
import { selectCurrent as selectSettings } from "../redux/settings/selectors";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { MultiSelect } from "react-multi-select-component";
import { settings } from "../redux/settings/actions";
import GoogleMapSearch from "../common/components/google-map-search";
import { useSelector } from "react-redux";
import { RadioGroup } from "@headlessui/react";
import { selectCmsSettingsListItems } from "../redux/cmsSettings/selector";
import { selectListItems as selectLibraryListItems } from "../redux/library/selector";
import { selectQuotesCreatedItem as selectCreateQuoteDetails } from "../redux/quotes/selector";
import { selectOrdersCreatedItem as selectCreateOrderDetails } from "../redux/orders/selector";
import { selectUpdatedItem as selectInitiateRazorpayDetails } from "../redux/razporpay/selector";
import _ from "lodash";
import { orders } from "../redux/orders/action";
import { getFormattedDate } from "../common/services/date.service";
import moment from "moment";
import { quotes } from "../redux/quotes/action";
import { razorpay } from "../redux/razporpay/action";
import storePersist from "../redux/storePersist";
import { addPayment } from "../redux/addPayment/action";
import { shippingTypes } from "../redux/shippingTypes/action";
import { selectShippingTypesListItems } from "../redux/shippingTypes/selector";
import { selectLeadsListItems } from "../redux/leads/selector";
import { selectProductsListItems } from "../redux/products/selector";
import { selectCategoriesListItems } from "../redux/categories/selector";
import { selectVariantsListItems } from "../redux/variants/selector";
import { selectShippingProvidersListItems } from "../redux/shipping-providers/selector";
import { shippingProviders } from "../redux/shipping-providers/action";
import { products } from "../redux/products/action";
import { variants } from "../redux/variants/action";
import { categories } from "../redux/categories/action";
import { paymentMethods } from "../redux/payment-methods/action";
import { channel } from "../redux/channel/action";
import { selectPaymentMethodsQueryItems } from "../redux/payment-methods/selector";
import { selectOrganizationUnitsListItems } from "../redux/organizationUnits/selector";
import queryString from "query-string";
import CryptoJS from 'crypto-js';
declare let Razorpay: any;
let currentChange: any = {};
export default function GetQuote() {
	interface ISteps {
		CategoryName: string;
		ItemName: string
		PackageType: string
		Weight: string
		Width: string
		Height: string
		Length: string
		AdditionalInfo: string
		NumberOfItems: number
	}
	// interface IPackage {
	// 	package: string
	// }
	const dispatch = useAppDispatch();
	const { getQuote } = useAppSelector(selectCurrent)
	const result = useSelector(selectCurrent)
	const [color, setColor] = useState('universal')
	const defaultSetting = useSelector(selectSettings)
	const { header, footer, visible, sidebar, theme, primary, secondary } = defaultSetting
	const leadDetails = useSelector(selectLeadsListItems)
	const quoteDetails = useSelector(selectCreateQuoteDetails)
	const paymentSettings = useSelector(selectCmsSettingsListItems)
	const libraryData = useSelector(selectLibraryListItems)
	const shippingTypesDetails = useSelector(selectShippingTypesListItems)
	const paymentMethodQuery = useSelector(selectPaymentMethodsQueryItems)
	const [isOrderTriggered, setIsOrderTriggered] = useState(false)
	const [isInitiateRazorpayTriggered, setIsInitiateRazorpayTriggered] = useState(false)
	const [quoteData, SetQuoteData] = useState<any>({});
	const [razorpaySettings, setRazorpaySettings] = useState<any>([])
	const handleChange: any = (event: any, field: string) => {
		SetQuoteData({ ...quoteData, [field]: event })
	}
	const [isOrderPlaced, setIsOrderPlaced] = useState<any>(false);
	const [isPaymentAdded, setIsPaymentAdded] = useState<any>(false);
	const ProductLists = useSelector(selectProductsListItems)
	const [productCount, setProductCount] = useState([1])
	// const [steps, setSteps] = useState<ISteps>({
	// 	CategoryName: '',
	// 	ItemName: '', PackageType: '', Weight: '', Width: '',
	// 	Length: '', Height: '', AdditionalInfo: '', NumberOfItems: 0
	// });
	var storeId = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization?.StoreId;
	const [paymentGateway, setPaymentGateway] = useState<any>([]);
	const shippingProvidersListItems = useSelector(selectShippingProvidersListItems)
	const variantLists = useSelector(selectVariantsListItems)
	const categoryListItems = useSelector(selectCategoriesListItems)
	const orderDetails = useSelector(selectCreateOrderDetails)
	const [orderId, setOrderId] = useState<any>()
	const organizationUnitLists = useSelector(selectOrganizationUnitsListItems)
	const [generateIds, setGenerateIds] = useState<any>([]);
	var tenantId = storePersist.get('guestTokenMetadata')?.current?.result?.TokenMetadata?.TenantId
	const MODE = 'test';

	useEffect(() => {
		setColor(theme)
	}, [theme]);
	const [count, setCount] = useState(1)
	const [pickupLocations, setPickupLocation] = useState<any>({
		name: result?.searchedLocation?.name || '',
		lat: result?.searchedLocation?.lat || '',
		long: result?.searchedLocation?.long || '',
		pincode: result?.searchedLocation?.pincode || '',
		description: result?.searchedLocation?.description || '',
	});
	const [dropLocations, setDropLocation] = useState<any>({
		name: result?.searchedToLocation?.name || '',
		lat: result?.searchedToLocation?.lat || '',
		long: result?.searchedToLocation?.long || '',
		pincode: result?.searchedToLocation?.pincode || '',
		description: result?.searchedToLocation?.description || '',
	});
	const [selectedInput, setSelectedInput] = useState("");
	const PackageType = [
		{ name: 'Standard Package' },
		{ name: 'Custom Package' }
	]
	const [productItems, setProductItems] = useState<any>([]);
	const addNewItemsRow = ({ selectedItemsArg }: any) => {
		const localSelectediem = JSON.parse(JSON.stringify(selectedItemsArg))
		const newsSelectedItem = {
			Id: 0,
			CategoryId: 0,
			LogisticsProductId: 0,
			quantity: 0,
		};
		if (
			localSelectediem.length === 0 ||
			localSelectediem[localSelectediem?.length - 1]?.CategoryId !==
			0 ||
			localSelectediem[localSelectediem?.length - 1]?.LogisticsProductId !== 0 ||
			localSelectediem[localSelectediem?.length - 1]?.quantity !== 0
		) {
			localSelectediem?.push(newsSelectedItem);
		}

		return localSelectediem;
	};
	const handleFormItemChange: any = ({ value, field, idx }: any) => {
		const items = JSON.parse(JSON.stringify(productItems)) // deep copy of grn items
		let item = items[idx]; // deep copy of item to be edited
		item = { ...item, [field]: value }; // updated the particular item
		items[idx] = item;
		currentChange = { value, field, idx };
		setProductItems(items);
	};

	const setCombinationInfo = async () => {
		let localSelectedItem = JSON.parse(JSON.stringify(productItems));
		localSelectedItem.splice(currentChange.idx, 1, {
			...localSelectedItem[currentChange.idx],
		});
		localSelectedItem = addNewItemsRow({ selectedItemsArg: localSelectedItem });
		currentChange = productCount;

		setProductItems(localSelectedItem);
	};

	useEffect(() => {
		// if (
		//   currentChange.field === 'category_type_Id' ||
		//   currentChange.field === 'item_name'
		// ) {
		//   setCombinationInfo();
		// }
	}, [productItems]);
	const items = [
		{
			name: 'Cash',
			description: 'Cash on delivery',
			value: 10,
			checked: '',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForCOD,
		},
		{
			name: 'Online',
			description: 'Payment gateway',
			value: 20,
			checked: 'checked',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForOnline,
		},
		{
			name: 'Wallet',
			description: 'Wallet',
			value: 40,
			checked: '',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForWallet,
		},
	];

	const [selected, setSelected] = useState(items[0].value);




	const handleMinus = (index: any, data: any) => {
		handleFormItemChange({
			value: data - 1,
			idx: index,
			field: 'quantity'
		})
	}

	const handlePlus = (index: any, data: any) => {

		handleFormItemChange({
			value: data + 1,
			idx: index,
			field: 'quantity'
		})
	}
	const handlePackage = (e: any) => {

		setSelectedInput(e.target.value)
	}

	const tutorialSteps = [
		{
			id: 1,
			title: 'Select Items',
			subTitle: 'List of Items',
			component: (


				<><div className="w-full flex flex-col  p-5 shadow rounded-xl">
					<div className="flex flex-row items-center justify-around w-full space-x-4">
						<div className="w-full pb-5">
							<label
								className="block  text-xs font-light"
							>
								Shipping Category
							</label>
							<div className="w-full  border-x border-y border-black border-opacity-50 text-xs rounded" >
								<select
									className={`w-full rounded  bg-opacity-0 teritary-${color} text-xs py-2 `}
									id="default"
									onChange={(event: any) => {
										handleChange(
											event.target.value,
											'category_id'
										)
									}}
									value={quoteData?.category_id}
								>

									<option>--Select--</option>
									{shippingTypesDetails?.result?.items?.map((item: any, index: any) => (
										<option value={item.ShippingTypeName} key={index}>{item.ShippingTypeName}</option>
									)
									)}

								</select>
							</div>
						</div>
						<div className="w-full pb-5">
							<label
								className="block  text-xs font-light"
							>
								Shipping type
							</label>
							<div className="w-full  border-x border-y border-black border-opacity-50 text-xs rounded" >
								<select
									className={`w-full rounded  bg-opacity-0 teritary-${color} text-xs py-2 `}
									id="default"
									onChange={(event: any) => {
										handleChange(
											event.target.value,
											'code'
										)
									}}
									value={quoteData?.code}
								>

									<option>--Select--</option>
									{libraryData?.result?.ShipmentType?.map((item: any, index: any) => (
										<option value={item.Text} key={index}>{item.Text}</option>
									)
									)}

								</select>
							</div>
						</div>
					</div>

				</div>
					{productItems?.map((item: any, index: any) => {
						return <div className="w-full flex flex-col  p-5 shadow rounded-xl">
							<div className="flex flex-row items-center justify-around w-full space-x-4">


								<div className="w-full flex justify-start items-center flex-col space-y-2 pb-5 " >
									{PackageType?.map((item: any, index: any) => (
										<div className="flex flex-row items-center justify-start w-full">
											<input
												name={item?.name}
												type="radio"
												placeholder=""
												checked={selectedInput == String(item?.name)}
												className={`mx-3 h-3 rounded  bg-opacity-0 teritary-${color}`}
												onChange={(event: any) => {
													handlePackage(event),
														handleFormItemChange({
															value: item?.name,
															idx: index,
															field: 'packageType'
														})
												}}
												value={item?.name}
											/>
											<div className="text-xs font-light">
												{item?.name}
											</div>
										</div>
									)
									)}
								</div>
							</div>
							<div className="flex flex-row items-center justify-around w-full space-x-4">
								<div className="w-full pb-5">
									<label
										className="block  text-xs font-light"
									>
										Category
									</label>
									<div className="w-full  border-x border-y border-black border-opacity-50 text-xs rounded" >
										<select
											className={`w-full rounded  bg-opacity-0 teritary-${color} text-xs py-2 `}
											id="default"
											onChange={(event: any) => {
												handleFormItemChange({
													value: event.target.value,
													idx: index,
													field: 'CategoryId'
												})
											}}
											value={item?.CategoryId}
										>

											<option>--Select--</option>
											{categoryListItems?.result?.items?.map((item: any, index: any) => (
												<option value={item.Id} key={index}>{item.Name}</option>
											)
											)}

										</select>
									</div>
								</div>
								<div className="w-full pb-5">
									<label
										className="block  text-xs font-light"
									>
										Product
									</label>
									<div className="w-full  border-x border-y border-black border-opacity-50 text-xs rounded" >
										<select
											className={`w-full rounded  bg-opacity-0 teritary-${color} text-xs py-2 `}
											id="default"
											onChange={(event: any) => {
												handleFormItemChange({
													value: event.target.value,
													idx: index,
													field: 'LogisticsProductId'
												})
											}}
											value={item?.LogisticsProductId}
										>

											<option>--Select--</option>
											{ProductLists?.result?.items?.map((item: any, index: any) => (
												<option value={item.Id} key={index}>{item.Name}</option>
											)
											)}

										</select>
									</div>
								</div>
								<div className="w-full pb-5">
									<label
										className="block  text-xs font-light"
									>
										Variant
									</label>
									<div className="w-full  border-x border-y border-black border-opacity-50 text-xs rounded" >
										<select
											className={`w-full rounded  bg-opacity-0 teritary-${color} text-xs py-2 `}
											id="default"
											onChange={(event: any) => {
												handleFormItemChange({
													value: event.target.value,
													idx: index,
													field: 'LogisticsVariantId'
												})
											}}
											value={item?.LogisticsVariantId}
										>

											<option>--Select--</option>
											{variantLists?.result?.items?.map((item: any, index: any) => (
												<option value={item.Id} key={index}>{item.Name}</option>
											)
											)}

										</select>
									</div>
								</div>
							</div>
							<div className="grid grid-cols-4 sm:grid-cols-4 lg:grid-cols-6 gap-4 my-3">
								<div className="w-full mb-5">
									<label
										className="block  text-xs font-light"
									>
										Dangerous
									</label>
									<div className="border-0  text-xs mr-0" >
										<input
											type="checkbox"
											name="DangerousGoods"
											className={`w-full h-5 border-x border-y border-black border-opacity-50 text-xs rounded  teritary-${color}`}
											onChange={(event: any) => {
												handleFormItemChange({
													value: event.target.checked,
													idx: index,
													field: 'dangerous_goods'
												})
											}}
											value={item?.dangerous_goods}
										/>
									</div>
								</div>

								<div className="w-full">
									<label
										className="block  text-xs font-light"
									>
										Weight
									</label>
									<div className="border-0   text-xs " >
										<input
											type="number"
											name="weight"
											className={`w-full px-3 py-1 border-x border-y border-black border-opacity-50 text-xs rounded  teritary-${color}`}
											onChange={(event: any) => {
												handleFormItemChange({
													value: event.target.value,
													idx: index,
													field: 'weight'
												})
											}}
											value={item?.weight}
										/>
									</div>
									<label
										className="block  text-xs font-light text-right"
									>
										in kg
									</label>
								</div>
								<div className="w-full">
									<label
										className="block  text-xs font-light"
									>
										Value
									</label>
									<div className="border-0   text-xs " >
										<input
											type="text"
											name="value"
											className={`w-full px-3 py-1 border-x border-y border-black border-opacity-50 text-xs rounded  teritary-${color}`}
											onChange={(event: any) => {
												handleFormItemChange({
													value: event.target.value,
													idx: index,
													field: 'value'
												})
											}}
											value={item?.value}
										/>
									</div>
									<label
										className="block  text-xs font-light text-right"
									>
										in ₹
									</label>
								</div>
								{selectedInput == 'Custom Package' ? <div className="w-full">
									<label
										className="block  text-xs font-light"
									>
										Measure
									</label>
									<div className="border-0   text-xs " >
										<input
											type="number"
											name="measure"
											className={`w-full px-3 py-1 border-x border-y border-black border-opacity-50 text-xs rounded teritary-${color}`}
											onChange={(event: any) => {
												handleFormItemChange({
													value: event.target.value,
													idx: index,
													field: 'measure'
												})
											}}
											value={item?.measure}
										/>
									</div>
									<label
										className="block  text-xs font-light text-right"
									>
										in mm
									</label>
								</div> : <div className="w-full"></div>}
								{selectedInput == 'Custom Package' ? <div className="w-full">
									<label
										className="block  text-xs font-light"
									>
										Breadth
									</label>
									<div className="border-0   text-xs " >
										<input
											type="number"
											name="breadth"
											className={`w-full px-3 py-1 border-x border-y border-black border-opacity-50 text-xs rounded teritary-${color}`}
											onChange={(event: any) => {
												handleFormItemChange({
													value: event.target.value,
													idx: index,
													field: 'breadth'
												})
											}}
											value={item?.breadth}
										/>
									</div>
									<label
										className="block  text-xs font-light text-right"
									>
										in mm
									</label>
								</div> : <div className="w-full"></div>}
								{selectedInput == 'Custom Package' ? <div className="w-full">
									<label
										className="block  text-xs font-light"
									>
										Height
									</label>
									<div className="border-0   text-xs " >
										<input
											type="number"
											name='height'
											className={`w-full px-3 py-1 border-x border-y border-black border-opacity-50 text-xs rounded teritary-${color}`}
											onChange={(event: any) => {
												handleFormItemChange({
													value: event.target.value,
													idx: index,
													field: 'Height'
												})
											}}
											value={item?.Height}
										/>
									</div>
									<label
										className="block  text-xs font-light text-right"
									>
										in mm
									</label>
								</div> : <div className="w-full"></div>}
								{selectedInput == 'Custom Package' ? <div className="w-full">
									<label
										className="block  text-xs font-light"
									>
										Length
									</label>
									<div className="border-0   text-xs " >
										<input
											type="number"
											name="length"
											className={`w-full px-3 py-1 border-x border-y border-black border-opacity-50 text-xs rounded teritary-${color}`}
											onChange={(event: any) => {
												handleFormItemChange({
													value: event.target.value,
													idx: index,
													field: 'Length'
												})
											}}
											value={item?.Length}
										/>
									</div>
									<label
										className="block  text-xs font-light text-right"
									>
										in mm
									</label>
								</div> : <div className="w-full"></div>}
							</div>
							<div className="flex flex-row justify-around items-end w-full">
								<div className="w-[380px]">
									<label className="text-xs font-light">Additonal Information</label>
									<div className=" border-x border-y border-black border-opacity-50 text-xs rounded" >
										<textarea
											name={"additionainfo"}
											placeholder=""
											className={`w-full h-10 rounded bg-black bg-opacity-0 text-xs px-4 py-3 teritary-${color}`}
											onChange={(event: any) => {
												handleFormItemChange({
													value: event.target.value,
													idx: index,
													field: 'item_description'
												})
											}}
											value={item?.item_description}
										/>
									</div>
								</div>
								<div className="w-[200px] px-5 flex flex-row justify-center items-center space-x-2"  >

									<svg
										onClick={() => handleMinus(index, item?.quantity)}
										fill={primary} height="18" width="18" className="cursour-pointer mt-3" version="1.1" id="Layer_1"
										viewBox="0 0 210.414 210.414">
										<path d="M105.207,0C47.196,0,0,47.196,0,105.207c0,58.011,47.196,105.207,105.207,105.207
				c58.011,0,105.207-47.196,105.207-105.207C210.414,47.196,163.218,0,105.207,0z M105.207,202.621
				c-53.715,0-97.414-43.699-97.414-97.414c0-53.715,43.699-97.414,97.414-97.414c53.715,0,97.414,43.699,97.414,97.414
				C202.621,158.922,158.922,202.621,105.207,202.621z"/>
										<path d="M155.862,101.31H54.552c-2.152,0-3.897,1.745-3.897,3.897c0,2.152,1.745,3.897,3.897,3.897h101.31
				c2.152,0,3.897-1.745,3.897-3.897C159.759,103.055,158.014,101.31,155.862,101.31z"/>
									</svg>
									<div className="w-full">
										<label
											className="block  text-xs font-light"
										>
											Number of Items
										</label>
										<div className="border-0   text-xs " >
											<input
												type="number"
												name="numberofitems"
												className={`w-full text-center px-3 py-1 border-x border-y border-black border-opacity-50 text-xs rounded teritary-${color}`}
												onChange={(event: any) => {
													handleFormItemChange({
														value: event.target.value,
														idx: index,
														field: 'quantity'
													})
												}}
												value={item?.quantity}
											/>
										</div>
									</div>
									<svg
										onClick={() => handlePlus(index, item?.quantity)}
										fill={primary} width="18" height="18" className="cursour-pointer mt-3" viewBox="0 0 32 32" version="1.1" >
										<path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM23 15h-6v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v6h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h6v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z"></path>
									</svg>
								</div>
								<div className="w-[100px] flex justify-end">
									{(index + 1) === productItems.length ? <button onClick={() => handleAdd()} className={`bg-blue-700 text-white px-2 text-xs py-1 rounded`}>
										Add
									</button> : ''}
								</div>
							</div>
						</div>
					})}

				</>




			),
			display: true,
		},
		{
			id: 2,
			title: 'Location Details',
			subTitle: 'Pickup Details',
			component: (

				<div className="w-full flex flex-col">
					<div className="flex flex-col">
						<div className=" w-full p-1">
							<label
								className="block text-xs font-bold mb-1 uppercase"
							>
								Shipping Option
							</label>
							<div className="w-full  border-x border-y border-black border-opacity-50 text-xs rounded" >
								<select
									className={`w-full rounded  bg-opacity-0 teritary-${color} text-xs py-2 `}
									id="default"
									onChange={(event: any) => {
										handleChange(
											event.target.value,
											'type'
										)
									}}
									value={quoteData?.type}
								>

									<option>--Select--</option>
									{libraryData?.result?.ShippingOption?.map((item: any, index: any) => (
										<option value={item.Text} key={index}>{item.Text}</option>
									)
									)}

								</select>
							</div>
						</div>
						<div className=" w-full p-1">
							<label
								className="block text-xs font-bold mb-1 uppercase"
								htmlFor="grid-password">
								PickUp Details
							</label>
							<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
								<GoogleMapSearch
									setLocation={setPickupLocation}
									location={pickupLocations}
									placeholder="Pickup Details" />
							</div>
						</div>
						<div className=" w-full p-1">
							<label
								className="block text-xs font-bold mb-1 uppercase"
								htmlFor="grid-password">
								Pickup Details Address Additional Info
							</label>
							<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
								<input
									type="type"
									name={"from"}
									placeholder=""
									className={`w-full py-2  bg-opacity-0 text-xs px-3 teritary-${color}`}
									onChange={(event: any) => {
										handleChange(
											event.target.value,
											'startBuilding'
										)
									}}
									value={quoteData?.startBuilding}
								/>
							</div>
						</div>
					</div>
					<div className="flex flex-col">

						<div className=" w-full p-1">
							<label
								className="block text-xs font-bold mb-1 uppercase"
								htmlFor="grid-password">
								Drop Details
							</label>
							<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
								<GoogleMapSearch
									setLocation={setDropLocation}
									location={dropLocations}
									placeholder="Drop Details" />
							</div>
						</div>
						<div className=" w-full p-1">
							<label
								className="block text-xs font-bold mb-1 uppercase"
								htmlFor="grid-password">
								Drop Details Address Additional Info
							</label>
							<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
								<input
									type="text"
									name={"from"}
									placeholder=""
									className={`w-full py-2  bg-opacity-0 text-xs px-3 teritary-${color}`}
									onChange={(event: any) => {
										handleChange(
											event.target.value,
											'endBuilding'
										)
									}}
									value={quoteData?.endBuilding}
								/>
							</div>
						</div>
					</div>
					{/* <div className="flex flex-row">
											<div className=" w-1/2 p-1">
												<label
													className="block text-xs font-bold mb-1 uppercase"
													htmlFor="grid-password">
													Cargo Type
												</label>
												<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
													<input
														type="type"
														name={"from"}
														placeholder=""
														className="w-full py-2 bg-black bg-opacity-0 text-xs px-3"
														onChange={(e) => console.log('')}
														value={""}
													/>
												</div>
											</div>
											<div className=" w-1/2 p-1">
												<label
													className="block text-xs font-bold mb-1 uppercase"
													htmlFor="grid-password">
													Ready To Load
												</label>
												<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
													<input
														type="date"
														name={"from"}
														placeholder=""
														className="w-full py-2 bg-black bg-opacity-0 text-xs px-3"
														onChange={(e) => console.log('')}
														value={""}
													/>
												</div>
											</div>
										</div> */}
				</div>

			),
			display: true,
		},

		{
			id: 3,
			title: 'Confirm Booking',
			subTitle: 'Order Summary',
			component: (
				<div className="w-full">
					<div className="mb-6 ">
						<h1> Order  Summary Details</h1>

					</div>
					<table className="w-full  font-semibold text-sm lg:text-base">
						<tfoot>
							<tr className={`secondary-${color}`}>
								<td className="p-4 italic">{"Amount Quoted "}</td>
								<td className="p-4"> {quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup[0]?.price?.value}</td>
							</tr>
							<tr className={`secondary-${color}`}>
								<td className="p-4 italic">{"Relocation Date"}</td>
								<td className="p-4">
									{leadDetails?.quoteData?.date ? getFormattedDate(leadDetails?.quoteData?.date) : moment().format('YYYY-MM-DD h:mm:ss a')}
									{/* <span className="text-[13px] font-normal ps-1.5 inline-block">
                via Flat rate
              </span> */}
								</td>
							</tr>
							<tr className={`secondary-${color}`}>
								<td className="p-4 italic">{"Service Type"}</td>
								<td className="p-4">{"Standard"}</td>
							</tr>
							<tr className={`secondary-${color}`}>
								<td className="p-4 italic">{"No of items added"}</td>
								<td className="p-4">{quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems?.length}</td>
							</tr>


							{/* <tr className="odd:bg-skin-secondary">
            <td className="p-4 italic">{useLocale('common', 'text-note')}:</td>
            <td className="p-4">{useLocale('common', 'text-new-order')}</td>
          </tr> */}
						</tfoot>
					</table>
				</div>
			),
			display: true,
		},
		{
			id: 4,
			title: 'Payment Option',
			subTitle: 'Select payment slot',
			component: (
				<div className="block">
					<div className="mt-2">
						<RadioGroup
							value={selected}
							onChange={setSelected}
							className="md:grid md:grid-cols-2 md:gap-5 auto-rows-auto space-y-4 md:space-y-0"
						>
							{items?.length > 0 ? (
								items?.map(
									(item: any, index: any) =>
										item.show && (
											<RadioGroup.Option
												key={index}
												value={item.value}
												className={({ checked }) =>
													`${checked ? ' border-blue-800' : ' border-blue-400'}
                    border-2 relative shadow-md focus:outline-none rounded-md p-5 block cursor-pointer min-h-[112px] h-full group address__box`
												}
											>
												<RadioGroup.Label
													as="h3"
													className=" font-semibold mb-2 -mt-1"
												>
													{item?.name}
												</RadioGroup.Label>
												<RadioGroup.Description
													as="div"
													className="  leading-6"
												>
													{item?.description}
												</RadioGroup.Description>
											</RadioGroup.Option>
										),
								)
							) : (
								<div className="border-2 border-skin-base rounded font-semibold p-5 px-10 text-skin-ouprimary flex justify-start items-center min-h-[112px] h-full">
									No payment option found
								</div>
							)}
						</RadioGroup>
					</div>
				</div>
			),
			display: true,
		},
	];

	const [activeStep, setActiveStep] = useState(0);
	const maxSteps = tutorialSteps.length;
	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};
	const handleClose = () => {
		SetQuoteData({})
		setProductItems([])
		dispatch(settings.set({ getQuote: 'close' }))
		setCount(1)
		setActiveStep(0)
		setPickupLocation({
			name: '',
			lat: '',
			long: '',
			pincode: '',
			description: ''
		})
		setDropLocation({
			name: '',
			lat: '',
			long: '',
			pincode: '',
			description: ''
		})
		//setProductCount([1])
	}

	// const handleSteps = (e: any, key: any) => {
	// 	setSteps({ ...steps, [key]: e.target.value })
	// }

	// const handlePackage = (e: any) => {
	// 	setSelectedInput(e.target.value)
	// }

	const handleAdd = () => {

		setProductCount([...productCount, 1])

		setCombinationInfo()
	}
	useEffect(() => {

	}, [count, selectedInput]);
	useEffect(() => {

	}, [selected])
	// const handleReset = () => {
	// 	setSteps({
	// 		CategoryName: '', ItemName: '',
	// 		PackageType: '', Weight: '',
	// 		Width: '', Height: '',
	// 		Length: '', AdditionalInfo: '',
	// 		NumberOfItems: 0

	// 	})
	// }
	const generateUniqueId = () => {
		const randomPart = Math.random().toString(36).substr(2, 9); // Random part
		const timestampPart = Date.now().toString(36); // Timestamp part
		return `${randomPart}-${timestampPart}`;
	};

	const generateIdValue = () => {
		const newItem = {
			transaction_id: generateUniqueId(),
			message_id: generateUniqueId(),
			fulfillment_id: generateUniqueId(),
			item_id: generateUniqueId(),
			order_id: generateUniqueId(),
		};
		setGenerateIds(newItem);
	};
	const userInfo = storePersist?.get("userProfile")?.current?.items;
	useEffect(() => {
		setRazorpaySettings(paymentMethodQuery?.result?.items?.RazorPayConfiguration);
		// setRazorpaySettings([
		// 	{
		// 		"Id": 3,
		// 		"RazorPayConfiguration": {
		// 			"RazorPayConfigurationPId": "97-ORD-JBN-2",
		// 			"StoreId": 183,
		// 			"GatewayName": "RazorPay",
		// 			"GatewayKey": "rzp_test_iS2R7go2pSvdA3",
		// 			"GatewaySecret": "px5DE484H7meoTSsSHepRx14",
		// 			"RazorPay": {
		// 				"GatewayName": "RazorPay",
		// 				"GatewayKey": "00000000",
		// 				"GatewaySecret": "00000000",
		// 				"IsActive": false
		// 			},
		// 			"CCAvenue": {
		// 				"GatewayName": "CCAvenue",
		// 				"WorkingKey": "351280CC07CE5C96BD46FCC3570879B4",
		// 				"MerchantId": "3096301",
		// 				"AccessCode": "AVCN05KL42CE88NCEC",
		// 				"IsActive": true
		// 			},
		// 			"PhonePe": {
		// 				"GatewayName": "PhonePe",
		// 				"SaltKey": "00000000",
		// 				"MerchantId": "00000000",
		// 				"SaltIndex": "00000000",
		// 				"IsActive": false
		// 			},
		// 			"IsActive": true,
		// 			"CreatedOnUtc": "2022-05-12T13:03:39.633",
		// 			"CreatedById": 231,
		// 			"ModifiedOnUtc": "2022-05-12T13:03:39.633",
		// 			"ModifiedById": 231
		// 		}
		// 	}
		// ])
	}, [paymentMethodQuery]);
	useEffect(() => {
		const gateways: any = []
		if (razorpaySettings?.RazorPay?.IsActive) {
			gateways.push({ Id: 10, title: 'Razorpay', detail: 'Razorpay' })
		}
		if (razorpaySettings?.CCAvenue?.IsActive) {
			gateways.push({ Id: 20, title: 'CC Avenue', detail: 'CC Avenue' })
		}
		if (razorpaySettings?.PhonePe?.IsActive) {
			gateways.push({ Id: 30, title: 'PhonePe', detail: 'PhonePe' })
		}
		setPaymentGateway(gateways);
	}, [razorpaySettings]);
	// Step 1: Submit Quotes
	const handleSaveQuote = () => {
		let shippingType = _.find(shippingTypesDetails.result.items, ['ShippingTypeName', quoteData.category_id]);
		const fromAddressData = _.split(pickupLocations?.description, ',');
		const toAddressData = _.split(dropLocations?.description, ',');

		const selectedProducts = productItems?.map((item: any) => {
			const product = {
				CategoryId: item?.CategoryId,
				LogisticsProductId: item?.LogisticsProductId,
				LogisticsVariantId: item?.LogisticsVariantId,
				quantity: {
					count: item?.quantity,
					measure: {
						unit: "kg",
						value: item?.measure || 0
					}
				},
				weight: {
					unit: "mm",
					value: item?.weight || 0
				},
				dimensions: {
					length: {
						unit: "mm",
						value: item?.Length || 0
					},
					breadth: {
						unit: "mm",
						value: item?.breadth || 0
					},
					height: {
						unit: "mm",
						value: item?.Height || 0
					}
				},
				value: {
					currency: "INR",
					value: item?.value || 0
				},
				dangerous_goods: item?.dangerous_goods
			}
			return product;
		});
		const valueData = {
			order: {
				IsCargoOrder: false,
				provider: {
					id: shippingProvidersListItems?.result?.items[0]?.AccountPId,
					locations: []
				},
				items:
					[{
						id: String(shippingType.Id),
						fulfillment_id: generateIds?.fulfillment_id,
						category_id: quoteData?.category_id,
						descriptor: {
							code: quoteData?.code
						},
						time: {
							label: "",
							duration: "",
							timestamp: moment().format('YYYY-MM-DD h:mm:ss a')
						}
					}],
				billing: {},
				payment: {},
				LinkedItems: selectedProducts,
				fulfillments: [
					{
						id: generateIds?.fulfillment_id,
						type: quoteData?.type,
						start: {
							location: {
								gps: `${pickupLocations?.lat} ,${pickupLocations?.long}`,
								address: {
									name: pickupLocations?.name,
									building: quoteData?.startBuilding,
									locality: `${fromAddressData[0]},${fromAddressData[1]}`,
									city: pickupLocations?.name,
									state: fromAddressData[3] || 'TamilNadu',
									country: 'India',
									area_code: pickupLocations?.pincode || ''
								}
							},
							contact: {
								phone: '',
								email: ''
							}
						},
						end: {
							location: {
								gps: `${dropLocations?.lat} ,${dropLocations?.long}`,
								address: {
									name: dropLocations?.name,
									building: quoteData?.endBuilding,
									locality: `${toAddressData[0]},${toAddressData[1]}`,
									city: dropLocations?.name,
									state: toAddressData[3] || 'TamilNadu',
									country: 'India',
									area_code: dropLocations?.pincode || ''
								}
							},
							contact: {}
						}
					}
				]
			}
		}
		dispatch(quotes.create(
			{
				url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/logistics-quotes`, entity: 'quotes',
				jsonData: {
					Records: [{
						context: {
							transaction_id: generateIds?.transaction_id,
							message_id: generateIds?.item_id,
						},
						message: valueData,
					}]
				}
			})).then(() => {

				handleNext();
			}).then(() => {
				setPickupLocation({
					name: '',
					lat: '',
					long: '',
					pincode: '',
					description: ''
				})
				setDropLocation({
					name: '',
					lat: '',
					long: '',
					pincode: '',
					description: ''
				})
			})

	}
	// Step 2: Add Payment
	const handleOrder = async () => {
		await dispatch(addPayment.update({
			url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dom/check-outs/add-payment`, entity: 'addPayment', jsonData: {
				Records: [
					{
						Id: quoteDetails?.result?.Records[0]?.message?.order?.Id,
						OwnerType: 'LogisticsOrder',
						PaidAmount: quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup[0]?.price?.value,
						PaymentRemarks: 'LogisticsOrder',
						PaymentMethodId: selected, // Number(sessionStorage.getItem('paymentmethod')),
						PaymentGatewayId: paymentGateway[0]?.Id || 0,
					},
				],
			}
		})).then(() => {
			setIsPaymentAdded(true);
		})
		await setIsOrderPlaced(true);
	};
	// Step 4: Confirm Logistics Order
	useEffect(() => {
		if (isPaymentAdded) {
			const itemValues = quoteDetails?.result?.Records[0]?.message?.order?.items?.map((item: any) => {
				const data = {
					id: item?.id,
					fulfillment_id: item?.fulfillment_id,
					category_id: item?.category_id,
					descriptor: {
						code: item?.descriptor?.code
					},
					time: {
						label: null,
						duration: null,
						timestamp: null
					}
				};
				return data;
			});

			const breakupValues = quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup?.map((item: any) => {
				const data = {
					"@ondc/org/item_id": item?.['@ondc/org/item_id'],
					"@ondc/org/title_type": item?.['@ondc/org/title_type'],
					"price": {
						"currency": item?.price?.currency,
						"value": item?.price?.value
					}
				};
				return data;
			});
			const fulfillmentValues = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments?.map((item: any) => {
				const data = {
					"id": item?.id,
					"type": item?.type,
					"@ondc/org/awb_no": null,
					"start": {
						"person": {
							"name": ''
						},
						"location": {
							"gps": item?.start?.location?.gps,
							"address": {
								"name": item?.start?.location?.address?.name,
								"building": item?.start?.location?.address?.building,
								"locality": item?.start?.location?.address?.locality,
								"city": item?.start?.location?.address?.city,
								"state": item?.start?.location?.address?.state,
								"country": item?.start?.location?.address?.country,
								"area_code": item?.start?.location?.address?.area_code
							}
						},
						"contact": {
							"phone": item?.start?.contact?.phone,
							"email": item?.start?.contact?.email
						},
						"instructions": {
							"code": null,
							"short_desc": null,
							"long_desc": null,
							"additional_desc": {
								"content_type": null,
								"url": null
							},
							"images": null

						},
						"time": {
							"label": null,
							"duration": null,
							"timestamp": null
						}
					},
					"end": {
						"person": {
							"name": ''
						},
						"location": {
							"gps": item?.end?.location?.gps,
							"address": {
								"name": item?.end?.location?.address?.name,
								"building": item?.end?.location?.address?.building,
								"locality": item?.end?.location?.address?.locality,
								"city": item?.end?.location?.address?.city,
								"state": item?.end?.location?.address?.state,
								"country": item?.end?.location?.address?.country,
								"area_code": item?.end?.location?.address?.area_code
							}
						},
						"contact": {
							"phone": item?.end?.contact?.phone || '',
							"email": item?.end?.contact?.email || ''
						},
						"instructions": {
							"code": null,
							"short_desc": null,
							"long_desc": null,
							"additional_desc": {
								"content_type": null,
								"url": null
							},
							"images": null
						},
						"time": {
							"label": null,
							"duration": null,
							"timestamp": null
						}
					},
					"@ondc/org/ewaybillno": null,
					"@ondc/org/ebnexpirydate": null,
					"tags": [
						{
							"code": null,
							"list": [
								{
									"code": null,
									"value": null
								}
							]
						}
					]
				};
				return data;
			});
			const linkedItemValues = quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems?.map((item: any) => {
				let category = _.find(categoryListItems?.result?.items, ['Id', item?.CategoryId]);
				let product = _.find(ProductLists?.result?.items, ['Id', item?.LogisticsProductId]);
				const data = {
					"CategoryName": category?.Name,
					"CategoryId": item?.CategoryId,
					"LogisticsProductId": item?.LogisticsProductId,
					"LogisticsVariantId": item?.LogisticsVariantId,
					"descriptor": {
						"name": product?.Name
					},
					"quantity": {
						"count": item?.quantity?.count,
						"measure": {
							"unit": item?.quantity?.measure?.unit,
							"value": item?.quantity?.measure?.value
						}
					},

					"price": {
						"currency": item?.value?.currency,
						"value": item?.value?.value
					},
					"dangerous_goods": item?.dangerous_goods
				};
				return data;
			});
			const tagValues = quoteDetails?.result?.Records[0]?.message?.order?.tags?.map((item: any) => {
				const data = {
					code: item?.code,
					list: item?.list?.map((listItem: any) => {
						const data = {
							"code": listItem?.code,
							"value": listItem?.value
						}
						return data;

					})
				};
				return data;
			});
			const orderData = {
				context: {
					transaction_id: quoteDetails?.result?.Records[0]?.Context?.transaction_id,
					message_id: generateIds?.fulfillment_id,
				},
				message: {
					order: {
						created_at: moment.utc(),
						updated_at: moment.utc(),
						id: generateIds.order_id,
						state: null,
						provider: {
							id: quoteDetails?.result?.Records[0]?.message?.order?.provider?.id,
							locations: quoteDetails?.result?.Records[0]?.message?.order?.provider?.locations
						},
						items: itemValues,
						quote: {
							price: {
								currency: quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.currency,
								value: quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.value,
							},
							breakup: breakupValues
						},
						fulfillments: fulfillmentValues,
						"billing": {
							"name": fulfillmentValues[0]?.start?.person?.name || '',
							"address": {
								"name": fulfillmentValues[0]?.start?.location?.address?.name || '',
								"building": fulfillmentValues[0]?.start?.location?.address?.building || '',
								"locality": fulfillmentValues[0]?.start?.location?.address?.locality || '',
								"city": fulfillmentValues[0]?.start?.location?.address?.city || '',
								"state": fulfillmentValues[0]?.start?.location?.address?.state || '',
								"country": fulfillmentValues[0]?.start?.location?.address?.country || '',
								"area_code": fulfillmentValues[0]?.start?.location?.address?.area_code || '',
							},
							"tax_number": '',
							"phone": '',
							"email": '',

						},
						"payment": {
							"@ondc/org/collection_amount": null,
							"collected_by": null,
							"type": null,
							"@ondc/org/settlement_details": [
								{
									"settlement_counterparty": null,
									"settlement_type": null,
									"upi_address": null,
									"settlement_bank_account_no": null,
									"settlement_ifsc_code": null
								}
							]
						},
						"@ondc/org/linked_order": {
							"items": linkedItemValues,
							"provider": {
								"descriptor": {
									"name": null
								},
								"address": {
									"name": organizationUnitLists?.result?.items[0]?.Name,
									"building": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Address1,
									"locality": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Address2,
									"city": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.City,
									"state": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.StateProvince?.Name,
									"country": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Country?.Name,
									"area_code": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.ZipPostalCode
								}
							},
							"order":
							{
								"id": null,
								"weight": {
									"unit": "mm",
									"value": 600
								},
								"dimensions": {
									"length": {
										"unit": "mm",
										"value": 50
									},
									"breadth": {
										"unit": "mm",
										"value": 60
									},
									"height": {
										"unit": "mm",
										"value": 30
									}
								}
							}

						},
						"tags": tagValues,

					}
				}
			}
			dispatch(orders.create({
				url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/confirm-logistics-order`,
				entity: 'orderCreate',
				jsonData: {
					Records: [orderData]
				}
			})).then(() => {
				setIsOrderPlaced(true);
			})
		}
	}, [isPaymentAdded])
	const encrypt1 = (plainText: string, workingKey: string): string => {
		// Create an MD5 hash of the workingKey
		const key = CryptoJS.MD5(workingKey).toString(CryptoJS.enc.Hex);

		// Initialization vector (IV)
		const iv = CryptoJS.enc.Hex.parse('000102030405060708090a0b0c0d0e0f');

		// Encrypt the plainText
		const encrypted = CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Hex.parse(key), {
			iv: iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		});

		// Return the encrypted text in hex format
		return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
	};
	const handeCCAvenuePayment = (orderDetails: any) => {
		const workingKey =
			razorpaySettings.CCAvenue?.WorkingKey; //Put in the 32-Bit key shared by CCAvenues.
		const accessCode =
			razorpaySettings.CCAvenue?.AccessCode;
		const merchantId =
			razorpaySettings.CCAvenue?.MerchantId;

		const companyName = localStorage.getItem("CompanyName");
		const channel = storePersist.get("channels").current.find((element: any) => element.SalesChannelName === "CSP");
		const tenant = companyName; //getBusinessCompanyName();
		const ChannelId = channel.Id //getSalesChannelId();

		// const guestTokenData = {
		// 	Channel: channel.SalesChannelName, //SalesChannelName(),
		// 	Requester: `https://${tenant}.csp.digiit.${process.env.REACT_APP_API_URL}/`,
		// 	StoreId: storeId,
		// 	SalesChannelId: ChannelId,
		// };
		// const accessTokenData = {
		// 	PhoneNumber: userInfo[0]?.PhoneNumber,
		// 	TenantName: tenant,
		// 	SalesChannelId: ChannelId,
		// };
		const ccAvenueData = {
			merchant_id: merchantId,
			order_id: orderDetails?.order?.id,
			currency: 'INR',
			amount: Number(orderDetails?.order?.quote?.price?.value), //Total Price,
			// redirect_url: `https://payments.digiit.ai/${tenant}/${storeId}/${ChannelId}/ccavResponseHandler`,
			// cancel_url: `https://payments.digiit.ai/${tenant}/${storeId}/${ChannelId}/ccavResponseHandler`,
			redirect_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channel?.Id}/${orderDetails?.order?.billing?.phone}/ccavResponseHandler`,
			cancel_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channel?.Id}/${orderDetails?.order?.billing?.phone}/ccavResponseHandler`,
			language: 'EN',
			billing_name: orderDetails?.order?.billing?.name,
			billing_address: orderDetails?.order?.billing?.address?.name,
			billing_city: orderDetails?.order?.billing?.address?.city,
			billing_state: orderDetails?.order?.billing?.address?.state,
			billing_zip: orderDetails?.order?.billing?.address?.area_code,
			billing_country: orderDetails?.order?.billing?.address?.country,
			billing_tel: orderDetails?.order?.billing?.phone,
			billing_email: orderDetails?.order?.billing?.email,
			delivery_name: orderDetails?.order?.fulfillments[0]?.end?.person?.name,
			delivery_address: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.name,
			delivery_city: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.city,
			delivery_state: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.state,
			delivery_zip: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.area_code,
			delivery_country: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.country,
			merchant_param1: tenant, //getOrganizationName(),
			merchant_param2: tenantId,
			merchant_param3: `${window.location.hostname}`,
			merchant_param4: '',
			merchant_param5: '',
			integration_type: 'iframe_normal',
			// promo_code:'PROMO8513',
			customer_identifier: '',
		};
		const body = queryString.stringify(ccAvenueData);

		const encRequest1 = encrypt1(body, workingKey);
		// let URL = `https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;
		let URL = `https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;

		window.location.href = URL;
		// router.push(URL);
	}
	useEffect(() => {
		if (isOrderPlaced) {
			switch (selected) {
				case 10: //cash payment
					handleClose()
					break;
				case 20: //online
					switch (paymentGateway[0]?.Id) {
						case 10: //razorpay
							// handeRazorpay()
							break;
						case 20: //ccavenue
							handeCCAvenuePayment(orderDetails?.result?.items?.Records[0]?.message)
							break;
						case 30: //phonepe
							break;
						default:
					}


					break;
				case 30: //wallet
					break;
			}

		}
	}, [isOrderPlaced])

	useEffect(() => {
		//fetchShippingTypes();
		// if (data?.isRecurringOrder) {
		//   const selectedProducts =
		// 	data?.itemsData?.ondc_org_linked_order?.items?.map((item) => {
		// 	  const product = {
		// 		category_type_Id: item?.category_id,
		// 		item_name: item?.descriptor?.name,
		// 		item_description: item?.descriptor?.name,
		// 		quantity: item?.quantity?.count,
		// 		weight: item?.quantity?.measure?.value,
		// 	  };
		// 	  return product;
		// 	});
		//   const localSelectedItems = addNewItemsRow({
		// 	selectedItemsArg: selectedProducts,
		//   });
		//   setProductItems(localSelectedItems);
		// } else {
		const localSelectedItems = addNewItemsRow({
			selectedItemsArg: productItems,
		});
		setProductItems(localSelectedItems);
		generateIdValue()
		dispatch(shippingTypes.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`, entity: 'shippingTypes', jsonData: {} }))
			.then(() => {
				dispatch(shippingProviders.list({
					url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/shipment-management/shipping-providers/list`, entity: 'shippingProviders', jsonData: {
					}
				}))
			}).then(() => {
				dispatch(products.list({ url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/products/list`, entity: 'products', jsonData: {} }))
			}).then(() => {
				dispatch(variants.list({
					url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/variants/list`, entity: 'variants', jsonData: {}
				}))
			})
			.then(() => {
				dispatch(categories.list({
					url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/categories/list`,
					entity: 'categories',
					jsonData: {}
				}));
			}).then(() => {
				dispatch(paymentMethods.query({
					url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/configuration/payment-management/payment-methods/query-by-tenants`, entity: 'paymentMethods', jsonData:
						{ "Tenants": [{ "Id": tenantId }] }
				}))
			}).then(() => {
				dispatch(channel.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/channels/list`, entity: 'channels', jsonData: {} }))
			})
		//}
	}, []);
	return (
		<>
			{getQuote == 'open' ? (
				<>
					<div className="absolute fixed inset-0 flex  justify-center items-center my-3 modal-overlay">
						<div className=" my-2">
							<div className={`rounded-lg shadow-lg flex flex-col w-[900px] bg-slate-50 h-[500px] overflow-auto bg-scroll`}>
								<div className="flex items-start justify-between w-full border-b p-2 ">
									<div className="flex w-full flex-col items-start justify-between text-xl" >
										Request a Quote  (Step {`${tutorialSteps[activeStep].id}/${maxSteps}`}) - {tutorialSteps[activeStep].title}
									</div>
									<div className="cursor-pointer mx-1">
										<svg onClick={() => handleClose()} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-x-circle"><circle cx="12" cy="12" r="10" /><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg>
									</div>
								</div>
								<div className="w-full flex flex-row p-3 border-b p-2 -500 py-5">
									<div className="w-1/4">
										{tutorialSteps[activeStep].title}
									</div>
									<div className="flex flex-col w-3/4 space-y-3">
										{tutorialSteps[activeStep].component}
									</div>
								</div>
								{/* <div className="w-full flex flex-row p-3 border-b p-2 border-blue-500 py-5">
									<div className="w-1/4">
										Cargor Details
									</div>
									<div className="flex flex-col w-3/4 space-y-3">
										{productCount?.map((item, index: any) => {
											return <div className="w-full flex flex-col  p-5 shadow rounded-xl">
												<div className="flex flex-row items-center justify-around w-full space-x-4">
													<div className="w-full pb-5">
														<label
															className="block  text-xs font-light"
														>
															Category Name
														</label>
														<div className="w-full px-3  border-x border-y border-black border-opacity-50 text-xs rounded" >
															<select
																className="w-full rounded bg-black bg-opacity-0 text-xs py-2 "
																onChange={(e) => handleSteps(e, 'CategoryName')}
																value={steps['CategoryName']}
															>
																<option  value="1" key={1}>--Select--</option>
																<option value="1" key={1}>Sofa</option>
															</select>
														</div>
													</div>
													<div className="w-full pb-5">
														<label
															className="block  text-xs font-light"
														>
															Item Name
														</label>
														<div className="w-full border-x border-y border-black border-opacity-50 text-xs rounded" >
															<input
																name={"itemname"}
																placeholder=""
																className="w-full rounded bg-black bg-opacity-0 text-xs p-2"
																onChange={(e) => handleSteps(e, 'ItemName')}
																value={steps['ItemName']}
															/>
														</div>
													</div>
													
													
													<div className="w-full flex justify-start items-center flex-col space-y-2 " >
														<div className="flex flex-row items-center justify-start w-full">
															<input
																name={"standard"}
																type="radio"
																placeholder=""
																checked={selectedInput === 'Standard Package'}
																className="mx-3 h-3 rounded bg-black bg-opacity-0"
																onChange={(e) => handlePackage(e)}
																value="Standard Package"
															/>
															<div className="text-xs font-light">
																Standard Package
															</div>
														</div>
														<div className="flex flex-row items-center justify-start w-full">
															<input
																name='package'
																type="radio"
																checked={selectedInput === 'Custom Package'}
																placeholder=""
																className="mx-3 h-6 rounded bg-black bg-opacity-0 text-xs py-3"
																onChange={(e) => handlePackage(e)}
																value="Custom Package"
															/>
															<div className="text-xs font-light">
																Custom Package
															</div>
														</div>
													</div> 
												</div>
												<div className="flex flex-row items-center justify-around w-full space-x-4">
												<div className="w-full">
														<label
															className="block  text-xs font-light"
														>
															Weight
														</label>
														<div className="w-full border-x border-y border-black border-opacity-50 text-xs rounded" >
															<input
																type="text"
																name="weight"
																className="w-full rounded bg-black bg-opacity-0 text-xs p-2"
																onChange={(e) => handleSteps(e, 'Weight')}
																value={steps['Weight']}
															/>
														</div>
														<label
															className="block  text-xs font-light text-right"
														>
															in kg
														</label>
													</div>
													<div className="w-full px-5 flex flex-row justify-center items-center space-x-2"  >
														<svg
															onClick={() => handlePlus()}
															fill="#000000" width="18" height="18" className="cursour-pointer mt-3" viewBox="0 0 32 32" version="1.1" >
															<path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM23 15h-6v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v6h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h6v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z"></path>
														</svg>
														<div className="w-full">
															<label
																className="block  text-xs font-light"
															>
																Number of Items
															</label>
															<div className="w-full border-x border-y border-black border-opacity-50 text-xs rounded" >
																<input
																	type="number"
																	name="numberofitems"
																	className="w-full rounded bg-black bg-opacity-0 text-xs p-2"
																	onChange={(e) => handleSteps(e, 'NumberOfItems')}
																	value={count}
																/>
															</div>
														</div>
														<svg
															onClick={() => handleMinus()}
															fill="#000000" height="18" width="18" className="cursour-pointer mt-3" version="1.1" id="Layer_1"
															viewBox="0 0 210.414 210.414">
															<path d="M105.207,0C47.196,0,0,47.196,0,105.207c0,58.011,47.196,105.207,105.207,105.207
				c58.011,0,105.207-47.196,105.207-105.207C210.414,47.196,163.218,0,105.207,0z M105.207,202.621
				c-53.715,0-97.414-43.699-97.414-97.414c0-53.715,43.699-97.414,97.414-97.414c53.715,0,97.414,43.699,97.414,97.414
				C202.621,158.922,158.922,202.621,105.207,202.621z"/>
															<path d="M155.862,101.31H54.552c-2.152,0-3.897,1.745-3.897,3.897c0,2.152,1.745,3.897,3.897,3.897h101.31
				c2.152,0,3.897-1.745,3.897-3.897C159.759,103.055,158.014,101.31,155.862,101.31z"/>
														</svg>
													</div>
													</div>
												 <div className="flex flex-row w-full  items-center justify-start space-x-10 my-3">
													<div className="w-full">
														<label
															className="block  text-xs font-light"
														>
															Weight
														</label>
														<div className="border-0   text-xs " >
															<input
																type="text"
																name="weight"
																className="w-full px-3 py-1 border-x border-y border-black border-opacity-50 text-xs rounded  "
																onChange={(e) => handleSteps(e, 'Weight')}
																value={steps['Weight']}
															/>
														</div>
														<label
															className="block  text-xs font-light text-right"
														>
															in kg
														</label>
													</div>
													{selectedInput == 'Custom Package' ? <div className="w-full">
														<label
															className="block  text-xs font-light"
														>
															Width
														</label>
														<div className="border-0   text-xs " >
															<input
																type="text"
																name="width"
																className="w-full px-3 py-1 border-x border-y border-black border-opacity-50 text-xs rounded "
																onChange={(e) => handleSteps(e, 'Width')}
																value={steps['Width']}
															/>
														</div>
														<label
															className="block  text-xs font-light text-right"
														>
															in mm
														</label>
													</div> : <div className="w-full"></div>}
													{selectedInput == 'Custom Package' ? <div className="w-full">
														<label
															className="block  text-xs font-light"
														>
															Height
														</label>
														<div className="border-0   text-xs " >
															<input
																type="text"
																name='height'
																className="w-full px-3 py-1 border-x border-y border-black border-opacity-50 text-xs rounded "
																onChange={(e) => handleSteps(e, 'Height')}
																value={steps['Height']}
															/>
														</div>
														<label
															className="block  text-xs font-light text-right"
														>
															in mm
														</label>
													</div> : <div className="w-full"></div>}
													{selectedInput == 'Custom Package' ? <div className="w-full">
														<label
															className="block  text-xs font-light"
														>
															Length
														</label>
														<div className="border-0   text-xs " >
															<input
																type="text"
																name={"length"}
																className="w-full px-3 py-1 border-x border-y border-black border-opacity-50 text-xs rounded "
																onChange={(e) => handleSteps(e, 'Length')}
																value={steps['Length']}
															/>
														</div>
														<label
															className="block  text-xs font-light text-right"
														>
															in mm
														</label>
													</div> : <div className="w-full"></div>}
												</div> 
												<div className="flex flex-row justify-around items-end w-full">
													<div className="w-full">
														<label className="text-xs font-light">Additonal Information</label>
														<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
															<textarea
																name={"additionainfo"}
																placeholder=""
																className="w-full h-10 rounded bg-black bg-opacity-0 text-xs px-4 py-3"
																onChange={(e) => handleSteps(e, 'AdditionalInfo')}
																value={steps['AdditionalInfo']}
															/>
														</div>
													</div>
													<div className="w-[200px] px-5 flex flex-row justify-center items-center space-x-2"  >
														<svg
															onClick={() => handlePlus()}
															fill="#000000" width="18" height="18" className="cursour-pointer mt-3" viewBox="0 0 32 32" version="1.1" >
															<path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM23 15h-6v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v6h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h6v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z"></path>
														</svg>
														<div className="w-full">
															<label
																className="block  text-xs font-light"
															>
																Number of Items
															</label>
															<div className="border-0   text-xs " >
																<input
																	type="number"
																	name="numberofitems"
																	className="w-full text-center px-3 py-1 border-x border-y border-black border-opacity-50 text-xs rounded "
																	onChange={(e) => handleSteps(e, 'NumberOfItems')}
																	value={count}
																/>
															</div>
														</div>
														<svg
															onClick={() => handleMinus()}
															fill="#000000" height="18" width="18" className="cursour-pointer mt-3" version="1.1" id="Layer_1"
															viewBox="0 0 210.414 210.414">
															<path d="M105.207,0C47.196,0,0,47.196,0,105.207c0,58.011,47.196,105.207,105.207,105.207
				c58.011,0,105.207-47.196,105.207-105.207C210.414,47.196,163.218,0,105.207,0z M105.207,202.621
				c-53.715,0-97.414-43.699-97.414-97.414c0-53.715,43.699-97.414,97.414-97.414c53.715,0,97.414,43.699,97.414,97.414
				C202.621,158.922,158.922,202.621,105.207,202.621z"/>
															<path d="M155.862,101.31H54.552c-2.152,0-3.897,1.745-3.897,3.897c0,2.152,1.745,3.897,3.897,3.897h101.31
				c2.152,0,3.897-1.745,3.897-3.897C159.759,103.055,158.014,101.31,155.862,101.31z"/>
														</svg>
													</div> 
													<div className="w-[100px] flex justify-end">
														{(index + 1) == productCount.length ? <button onClick={() => handleAdd()} className="bg-blue-500 text-white px-2 text-xs py-1 rounded">
															Add
														</button> : ''}
													</div>
												</div>
											</div>
										})}
									</div>
								</div> */}
								{/* <div className="w-full flex flex-row p-3 border-b p-2 border-blue-500 py-5">
									<div className="w-1/4">
										Request Details
									</div>
									<div className="w-3/4 flex flex-col">
										<div className="flex flex-row">
											<div className=" w-1/2 p-1">
												<label
													className="block text-xs font-bold mb-1 uppercase"
													htmlFor="grid-password">
													PickUp Details
												</label>
												<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
												<GoogleMapSearch
												setLocation={setPickupLocation}
												location={pickupLocations}
												placeholder="Pickup Details" />
												</div>
											</div>
											<div className=" w-1/2 p-1">
												<label
													className="block text-xs font-bold mb-1 uppercase"
													htmlFor="grid-password">
													Drop Details
												</label>
												<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
												<GoogleMapSearch
												setLocation={setDropLocation}
												location={dropLocations}
												placeholder="Drop Details" />
												</div>
											</div>
										</div>
										<div className="flex flex-row">
											<div className=" w-1/2 p-1">
												<label
													className="block text-xs font-bold mb-1 uppercase"
													htmlFor="grid-password">
													Pickup Details Address Additional Info
												</label>
												<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
													<input
														type="type"
														name={"from"}
														placeholder=""
														className="w-full py-2 bg-black bg-opacity-0 text-xs px-3"
														onChange={(e) => console.log('')}
														value={""}
													/>
												</div>
											</div>
											<div className=" w-1/2 p-1">
												<label
													className="block text-xs font-bold mb-1 uppercase"
													htmlFor="grid-password">
													Drop Details Address Additional Info
												</label>
												<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
													<input
														type="text"
														name={"from"}
														placeholder=""
														className="w-full py-2 bg-black bg-opacity-0 text-xs px-3"
														onChange={(e) => console.log('')}
														value={""}
													/>
												</div>
											</div>
										</div>
										 <div className="flex flex-row">
											<div className=" w-1/2 p-1">
												<label
													className="block text-xs font-bold mb-1 uppercase"
													htmlFor="grid-password">
													Cargo Type
												</label>
												<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
													<input
														type="type"
														name={"from"}
														placeholder=""
														className="w-full py-2 bg-black bg-opacity-0 text-xs px-3"
														onChange={(e) => console.log('')}
														value={""}
													/>
												</div>
											</div>
											<div className=" w-1/2 p-1">
												<label
													className="block text-xs font-bold mb-1 uppercase"
													htmlFor="grid-password">
													Ready To Load
												</label>
												<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
													<input
														type="date"
														name={"from"}
														placeholder=""
														className="w-full py-2 bg-black bg-opacity-0 text-xs px-3"
														onChange={(e) => console.log('')}
														value={""}
													/>
												</div>
											</div>
										</div> 
									</div>
								</div> */}
								{/* <div className="w-full flex flex-row p-3 border-b p-2 border-blue-500">
									<div className="w-1/4">
										Associate Services
									</div>
									<div className="w-3/4">
										<div className="text-sm capitalize flex flex-row w-full justify-start items-center p-2">
											<div className="w-1/3">
												<input
													type="checkbox"
													name={"from"}
													placeholder=""
													className="rounded px-2  bg-black bg-opacity-0 text-xs"
													onChange={(e) => console.log('')}
													value={""}
												/> Insurance
											</div>
											<div className="w-1/3">
												<input
													type="checkbox"
													name={"from"}
													placeholder=""
													className="rounded px-2 bg-black bg-opacity-0 text-xs"
													onChange={(e) => console.log('')}
													value={""}
												/> Custom Clearance
											</div>
											<div className="w-1/3">
												<input
													type="checkbox"
													name={"from"}
													placeholder=""
													className="rounded px-2 bg-black bg-opacity-0 text-xs"
													onChange={(e) => console.log('')}
													value={""}
												/> Certification
											</div>
										</div>
										<div className="flex flex-row space-x-2">
											<div className=" w-full">
												<label className="text-xs font-bold uppercase">Additonal Information</label>
												<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
													<textarea
														name={"from"}
														placeholder=""
														className="w-full rounded bg-black bg-opacity-0 text-xs px-3 py-2"
														onChange={(e) => console.log('')}
														value={""}
													/>
												</div>
											</div>
										</div>
									</div>
								</div> */}
								{/* <div className="w-full flex flex-row p-3 border-b p-2 border-blue-500">
									<div className="w-1/4">
										Contact Details
									</div>
									<div className="w-3/4 h-20 bg-orange-100 flex flex-col space-y-4 py-2 pl-5">
										<span className="text-sm capitalize  ">
											Please fill out the form below or sign in to your account. Your progress won't get lost.
										</span>
										<span className="text-md capitalize text-orange-500 font-bold ">
											Sign In &rarr;
										</span>
									</div>
								</div> */}
								{/* <div className="w-full flex flex-row p-3 border-b p-2 border-blue-500">
									<div className="w-1/4">
										Sign Up
									</div>
									<div className="w-3/4 flex flex-col">
										<div className="flex flex-row">
											<div className=" w-1/2 p-1">
												<label
													className="block text-xs font-bold mb-1 uppercase"
													htmlFor="grid-password">
													First Name
												</label>
												<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
													<input
														type="type"
														name={"from"}
														placeholder=""
														className="w-full py-2 bg-black bg-opacity-0 text-xs px-3"
														onChange={(e) => console.log('')}
														value={""}
													/>
												</div>
											</div>
											<div className=" w-1/2 p-1">
												<label
													className="block text-xs font-bold mb-1 uppercase"
													htmlFor="grid-password">
													Last Name
												</label>
												<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
													<input
														type="type"
														name={"from"}
														placeholder=""
														className="w-full py-2 bg-black bg-opacity-0 text-xs px-3"
														onChange={(e) => console.log('')}
														value={""}
													/>
												</div>
											</div>
										</div>
										<div className="flex flex-row">
											<div className=" w-1/2 p-1">
												<label
													className="block text-xs font-bold mb-1 uppercase"
													htmlFor="grid-password">
													Email
												</label>
												<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
													<input
														type="type"
														name={"from"}
														placeholder=""
														className="w-full py-2 bg-black bg-opacity-0 text-xs px-3"
														onChange={(e) => console.log('')}
														value={""}
													/>
												</div>
											</div>
											<div className=" w-1/2 p-1">
												<label
													className="block text-xs font-bold mb-1 uppercase"
													htmlFor="grid-password">
													Phone Number
												</label>
												<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
													<input
														type="date"
														name={"from"}
														placeholder=""
														className="w-full py-2 bg-black bg-opacity-0 text-xs px-3"
														onChange={(e) => console.log('')}
														value={""}
													/>
												</div>
											</div>
										</div>
										<div className="flex flex-row justify-end items-center space-x-2 py-2 ">
											<button className="border-x border-y border-[#2A4574] text-[#2A4574] px-2 py-1 text-sm font-bold">
												Create Account
											</button>
										</div>
									</div>
								</div> */}
								<div className="w-full flex flex-row p-3 ">
									<div className="w-1/4">

									</div>
									{tutorialSteps[activeStep].id === maxSteps ? (
										<div className="w-3/4">
											<div className="flex flex-row justify-end items-center space-x-2">
												<button disabled={activeStep === 1} onClick={handleBack} className={`primary-${color} border-x border-y  px-2 py-1 text-sm font-bold`}>
													Back
												</button>
												<button onClick={handleClose} className={`primary-${color} border-x border-y  px-2 py-1 text-sm font-bold`}>
													Book Later
												</button>
												<button onClick={handleOrder} className={`primary-${color} border-x border-y  px-2 py-1 text-sm font-bold`}>
													Confirm Booking
												</button>
											</div>
										</div>) : (
										<>
											<div className="w-3/4">
												<div className="flex flex-row justify-end items-center space-x-2">
													{activeStep !== 0 && (<button onClick={handleBack} className={`primary-${color} border-x border-y  px-2 py-1 text-sm font-bold`}>
														Back											</button>)}

													{tutorialSteps[activeStep].id !== 2 && (<button onClick={handleNext} disabled={activeStep === maxSteps - 1} className={`primary-${color} border-x border-y  px-2 py-1 text-sm font-bold`}>
														Next
													</button>)}
													{tutorialSteps[activeStep].id === 2 && (<button onClick={handleSaveQuote} disabled={activeStep === maxSteps - 1} className={`primary-${color} border-x border-y  px-2 py-1 text-sm font-bold`}>
														Next
													</button>)}

												</div>
											</div>
										</>
									)}

								</div>
							</div>
						</div>
					</div>
				</>
			) : null
			}
		</>
	);
}